import { useUnit } from 'effector-react'

import { $roles, $totalCountOfRoles, getRoles, rolesListMounted } from './model'
import { RolesRequest } from './types'

export const useRolesList = () => {
  const loading = useUnit(getRoles.pending)
  const roles = useUnit($roles)
  const totalCountOfRoles = useUnit($totalCountOfRoles)

  const onChangeRolesList = (params: RolesRequest) => {
    rolesListMounted(params)
  }

  return { roles, loading, onChangeRolesList, totalCountOfRoles }
}
